import React, { useState, useRef, useEffect } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { CloudUpload, Trash2 } from 'lucide-react';
import { toast } from 'react-toastify';

const MB_Size = 2;
const MAX_IMAGE_SIZE = MB_Size * 1024 * 1024;

const UploadCropper = ({
  placeholder = "Choose a file or drag & drop here",
  disabled = false,
  RemoveCropper,
  onRemove,
  cropBoxWidth = 10,
  cropBoxHeight = 10,
  cropWidth = '402px',
  cropHeight = '220px',
  onCropInit = () => { },
  defaultImage = null,
  preview=''
}) => {
  const [imageSrc, setImageSrc] = useState('');
  const [imageSelected, setImageSelected] = useState(false);
  const [dragging, setDragging] = useState(false);
  const cropperRef = useRef(null);
  const fileInputRef = useRef(null);
  const [isDefaultLoaded, setIsDefaultLoaded] = useState(false);

  useEffect(() => {
    if (defaultImage) {
      setImageSrc(defaultImage);
      setImageSelected(true);
      setIsDefaultLoaded(true);
    }
  }, [defaultImage]);

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (validateImage(file)) readImage(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const file = e.dataTransfer.files[0];
    if (validateImage(file)) readImage(file);
  };

  const validateImage = (file) => {
    if (!file) return false;
    if (file.size > MAX_IMAGE_SIZE) {
      toast.error(`Image size must be less than ${MB_Size}MB`);
      return false;
    }
    return true;
  };

  const readImage = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      setImageSrc(reader.result);
      setImageSelected(true);
      setIsDefaultLoaded(false);
    };
    reader.readAsDataURL(file);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDelete = () => {
    setImageSrc('');
    setImageSelected(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleCrop = () => {
    if (isDefaultLoaded) return;
    if (cropperRef.current) {
      const cropper = cropperRef.current.cropper || cropperRef.current;
      const canvas = cropper.getCroppedCanvas();
      if (canvas) {
        const base64Data = canvas.toDataURL().substring(22);
        onCropInit({ croppedData: base64Data }); // ✅ fixed here
      }
    }
  };

  return (
    <>

      <div
        className={`cropper-card white ${disabled ? 'opacity-50 cursor_none' : ''}`}
        style={{ width: cropWidth, height: cropHeight }}
      >
        <div
          className={`upload-box ${dragging ? 'dragging' : ''}`}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          {RemoveCropper && onRemove && (
            <div className="remove-cropper" onClick={onRemove}>
              {RemoveCropper}
            </div>
          )}

          {!disabled && (
            <input
              id={placeholder}
              type="file"
              accept="image/jpeg,image/png"
              onChange={handleChange}
              ref={fileInputRef}
              className={imageSelected ? 'hidden' : ''}
            />
          )}

          {imageSelected ? (
            <>
              <Cropper
                ref={cropperRef}
                src={imageSrc}
                className="cropper"
                preview={preview}
                guides={true}
                minCropBoxWidth={cropBoxWidth}
                minCropBoxHeight={cropBoxHeight}
                viewMode={1}
                background={false}
                responsive={true}
                checkOrientation={false}
                crop={handleCrop}
                restore={false}
                autoCropArea={1}
                cropBoxResizable={true}

              />
              <div className="delete" onClick={handleDelete}>
                <Trash2 size={20} />
              </div>
            </>
          ) : (
            <>
              <div className="exta-info">{placeholder}</div>
              <div className="thumnail">
                <CloudUpload size={42} />
                <p>Click to upload or drag and drop</p>
                <span>JPG or PNG, up to {MB_Size}MB</span>
              </div>
            </>
          )}
        </div>
      </div>
      
    </>
  );
};

export default UploadCropper;
